import React, { useState, useCallback, useMemo } from 'react';
import './Join.css';
import Button from '../primitives/Button/Button';
import Input from '../primitives/Input/Input';
import { DEFAULT_ROOM_ID, JOIN_ROOM_URL_INFIX } from '../../../utils/constants';
import HeaderWithBack from '../primitives/HeaderWithBack/HeaderWithBack';

const Join: React.FC<{ onJoin: (value: string) => void }> = ({ onJoin }) => {
  const [roomId, setRoomId] = useState(DEFAULT_ROOM_ID);

  const handleChange = useCallback((value: string) => {
    if (value.includes(JOIN_ROOM_URL_INFIX)) {
      const splitValue = value.split(JOIN_ROOM_URL_INFIX);
      if (splitValue.length === 2) {
        setRoomId(splitValue[1] === roomId ? splitValue[1] + ' ' : splitValue[1]);
      } 
    } else {
      setRoomId(value);
    }
  }, [roomId]);

  const handleSubmit = useCallback(() => {
    onJoin(roomId);
    setRoomId(DEFAULT_ROOM_ID);
  }, [onJoin, roomId]);

  const handleChangeInput = useMemo(() => (
    <Input initialValue={roomId} onChange={handleChange} trim={true} />
  ), [roomId, handleChange])

  const handleSubmitButton = useMemo(() => (
    <Button onClick={handleSubmit} label='Submit' />
  ), [handleSubmit])

  const headerWithBackElement = useMemo(() => (
    <HeaderWithBack title={'Join'} />
  ), [])

  return (
    <div className='root'>
      { headerWithBackElement }
      <div className='join-container'>
        { handleChangeInput }
        { handleSubmitButton }
      </div>
    </div>
  );
};

export default Join;
